import { render, staticRenderFns } from "./RemovableAttachment.vue?vue&type=template&id=6a181a89&"
import script from "./RemovableAttachment.vue?vue&type=script&lang=js&"
export * from "./RemovableAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports